import { DocumentListItem, ProviderLink } from '@all-manager/design-system-v2';
import type { DocumentRowData } from '../../types/documentRow';
import DocumentMenuAction from '../DocumentMenuAction/DocumentMenuAction';
import { useDocumentRow } from './useDocumentRow';

type Props = {
  document: DocumentRowData;
  /** Hide the provider, e.g. inside the provider's own page. */
  hideProvider?: boolean;
};

export default function DocumentRow(props: Props) {
  const hook = useDocumentRow(props);

  return (
    <DocumentListItem
      name={props.document.name}
      href={props.document.file_url}
      type={hook.type}
      provider={!props.hideProvider && hook.providerHref ? (
        <ProviderLink
          name={hook.providerName}
          href={hook.providerHref}
          onClick={hook.handleProviderClick}
          variant="body2"
          noWrap
        />
      ) : undefined}
      date={hook.date}
      dateTime={hook.dateTime}
      thumbnailUrl={hook.thumbnailUrl}
      action={hook.isAdmin ? <DocumentMenuAction document={hook.editableDocument} /> : undefined}
    />
  );
}
